// extracted by mini-css-extract-plugin
module.exports = {"noResults":"Scroll_noResults__10FHZ"};